import type { ReactElement } from 'react';
import { motion } from 'framer-motion';

import type { TSkeletonProps } from './skeleton.interface';

export const Skeleton = ({
  variant,
  duration = 1,
  delay = 0
}: TSkeletonProps): ReactElement => {
  return (
    <motion.div
      initial={{
        opacity: 0.1
      }}
      animate={{
        opacity: 1
      }}
      transition={{
        ease: 'easeOut',
        duration,
        repeat: Infinity,
        delay,
        repeatType: 'reverse'
      }}
      className={`
            co-oliwi
                co-bg-gray-light
                co-h-full
                co-w-full
                ${variant === 'circular' ? 'co-rounded-full' : 'co-rounded-sm'}
                co-flex
                co-overflow-hidden`}
    >
      <motion.div
        initial={{
          x: '-200%',
          skewX: -20,
          opacity: 0
        }}
        animate={{
          x: '300%',
          opacity: 1
        }}
        transition={{
          ease: 'easeOut',
          duration,
          delay,
          repeat: Infinity,
          repeatDelay: duration
        }}
        className="
                    co-w-1/2
                    co-h-full
                    co-bg-gradient-to-r
                    co-from-transparent
                    co-via-white
                    co-to-transparent"
      />
    </motion.div>
  );
};
